import { httpRequest } from '@/services/httpClient'

export interface DepartmentStat {
  departmentId: number
  departmentName: string
  employeeCount: number
}

export interface RecentEmployee {
  employeeId: number
  name: string
  surname: string | null
  email: string | null
  hireDate: string | null
  createdAt: string
}

export interface DashboardStats {
  totalEmployees: number
  activeEmployees: number
  inactiveEmployees: number
  totalOrganizations: number
  totalDepartments: number
  totalUsers: number
  activeUsers: number
  departmentDistribution: DepartmentStat[]
  recentEmployees: RecentEmployee[]
  generatedAt: string
}

export const dashboardApi = {
  getStats: (tenantId?: number) =>
    httpRequest<DashboardStats>('/v1/dashboard/stats', {
      method: 'GET',
      query: { tenantId },
    }),
}
